<template>
  <v-container fluid class="pa-0">
    <v-container fluid class="pa-0">
      <v-row class="ma-0">
        <v-col col="12" class="pa-2">
          <v-card flat class="card-dias-planta-abate">
            <v-container fluid class="pa-0">
              <v-row class="ma-0">
                <v-col cols="6" class="pa-2 d-flex flex-column">
                  <v-row class="ma-0 d-flex flex-column flex-fill">
                    <span class="label-card-dados-planta">Alocados</span>
                    <span class="value-card-dados-planta">{{
                      qtTotalAnimaisAlocadoDia
                    }}</span>
                  </v-row>
                  <v-row class="ma-0 d-flex flex-column flex-fill">
                    <span class="label-card-dados-planta">Lotes</span>
                    <span class="value-card-dados-planta">{{
                      listaLotesFiltrada.length
                    }}</span>
                  </v-row>
                </v-col>
                <v-col cols="6" class="pa-2 d-flex flex-column">
                  <v-row class="ma-0 d-flex flex-column flex-fill">
                    <span class="label-card-dados-planta">Peso Médio</span>
                    <span class="value-card-dados-planta kg">
                      {{ nrPesoMedioDia }}
                    </span>
                  </v-row>
                  <v-row class="ma-0 d-flex flex-column flex-fill">
                    <span class="label-card-dados-planta">Distância total</span>
                    <span
                      class="value-card-dados-planta"
                      :class="[
                        {
                          km: nrDistanciaTotal !== '-'
                        }
                      ]"
                    >
                      {{ nrDistanciaTotal }}
                    </span>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid v-if="showLotes" class="pa-0">
      <v-col v-for="(itemLote, i) in listaLotesFiltrada" :key="i">
        <CardItemLoteAlocadoProgramacao
          :itemLote="itemLote"
          :itemData="itemData"
          :itemPlanta="itemPlanta"
        />
      </v-col>
    </v-container>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { daysBetweenDates } from "@/filters/utils";

import CardItemLoteAlocadoProgramacao from "@/modules/programacaoAbate/components/CardItemLoteAlocadoProgramacao";

export default {
  name: "CardProgramacaoLoteColunm",
  components: {
    CardItemLoteAlocadoProgramacao
  },
  props: {
    itemData: {
      type: Object,
      default: {}
    },
    itemPlanta: {
      type: Object,
      default: {}
    },
    showLotes: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState("programacaoAbate", [
      "programacaoAbateSelected",
      "listaDatas",
      "listBatchsAllocated"
    ]),
    listaLotesFiltrada() {
      if (this.programacaoAbateSelected.cdStatusProgramacaoAbate >= 3) {
        if (this.listBatchsAllocated) {
          let context = this;
          let listaFiltrada = this.listBatchsAllocated
            .filter(x => x.cdPlantaAbate == this.itemPlanta.cdPlantaAbate)
            .filter(y => y.stDiaAlocado == this.itemData.value);

          let listaFiltradaCalculada = listaFiltrada.map(entry => {
            let dataAlocado = context.listaDatas.find(
              x => x.value == entry.stDiaAlocado
            );
            var nrDiasAlojado = context.daysBetweenDates(
              dataAlocado.text,
              "DD/MM/YYYY",
              entry.loteProducao.dtAlojamento,
              "YYYYY-MM-DD"
            );
            return { ...entry, nrDiasAlojado };
          });

          listaFiltradaCalculada.forEach(item => {
            this.totalAnimaisAlocadoDiaPlanta =
              parseInt(this.totalAnimaisAlocadoDiaPlanta) +
              item.qtAnimaisAlocados;
          });

          return listaFiltradaCalculada;
        }
      }
      return [];
    },
    qtTotalAnimaisAlocadoDia() {
      let total = 0;
      this.listaLotesFiltrada.forEach(function(item) {
        total = (parseInt(total) | 0) + (parseInt(item.qtAnimaisAlocados) | 0);
      });
      return total;
    },
    nrPesoMedioDia() {
      let pesoTotal = 0;
      let qtItems = 0;
      let nrPesoMedio = 0;
      this.listaLotesFiltrada.forEach(function(item) {
        if (item.nrPesoDia) {
          pesoTotal = pesoTotal + item.nrPesoDia;
          qtItems = qtItems + 1;
          nrPesoMedio = (pesoTotal / qtItems).toFixed(1);
        }
      });
      return nrPesoMedio;
    },
    nrDistanciaTotal() {
      let nrDistancia = 0;
      this.listaLotesFiltrada.forEach(function(item) {
        if (item.distanciaPlanta) {
          if (item.distanciaPlanta.nrValor != "-") {
            nrDistancia =
              nrDistancia + (parseInt(item.distanciaPlanta.nrValor) | 0);
          } else {
            nrDistancia = nrDistancia + 0;
          }
        }
      });
      if (nrDistancia != 0) {
        return nrDistancia;
      } else {
        return "-";
      }
    }
  },
  methods: {
    daysBetweenDates,
    ...mapActions("programacaoAbate", [
      "ActionLoadCheckList",
      "ActionLoadDistanciaPlantaAbateEstabelecimento"
    ])
  }
};
</script>
